module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isDataLoaded) ? _c('div', {
    attrs: {
      "id": "view-coache-container"
    }
  }, [_c('div', {
    staticClass: "container is-fluid levebar-container"
  }, [_c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left is-hidden-mobile"
  }, [(_vm.breadcrumbList) ? _c('breadcrumb', {
    attrs: {
      "list": _vm.breadcrumbList
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "view-coach"
    }
  }, [_c('coach-info', {
    attrs: {
      "coach": _vm.coach
    }
  }), _vm._v(" "), _c('coach-screensaver', {
    attrs: {
      "coach": _vm.coach
    }
  }), _vm._v(" "), _c('coach-categories')], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a4944a6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coach/Coach.vue
// module id = 346
// module chunks = 1